<template>
    <div>
        <div class="navbar" ref="navbar">
            <div class="navbar-left">
                <breadcrumb></breadcrumb>
            </div>
            <div class="navbar-right">
                <el-dropdown trigger="click">
                    <div class="nickname">
                        <el-icon class="photo"><avatar /></el-icon>
                        <h4>欢迎您， {{ userInfo.username }}</h4>
                    </div>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item @click="baseinfoHandler">
                                <span> <i class="el-icon-s-custom"></i>个人信息 </span>
                            </el-dropdown-item>
                            <el-dropdown-item @click="logout">
                                <span> <i class="el-icon-switch-button"></i>退出系统</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </div>
        </div>
        <base-info :visible="baseinfoVisible" :userinfo="userInfo" @close="handlerClose"></base-info>
    </div>
</template>
<script setup>
import Breadcrumb from './breadcrumb.vue';
import BaseInfo from './baseInfo.vue';
import { Avatar } from '@element-plus/icons-vue';
import { useRouter } from 'vue-router';
import cookie from '../commons/cookie';
import { ref } from 'vue';

const userInfo = ref(null);
const router = useRouter();
const baseinfoVisible = ref(false);

const baseinfoHandler = function () {
    baseinfoVisible.value = true;
};

const handlerClose = function () {
    baseinfoVisible.value = false;
};

const logout = function () {
    localStorage.clear();
    cookie.clear('token');
    router.push({
        path: '/login'
    });
};
const getUserInfo = function () {
    const token = localStorage.getItem('userinfo');
    const info = JSON.parse(token);
    userInfo.value = info || {};
};
getUserInfo();

const handleUserinfo = () => {};
</script>
<style lang="scss" scoped>
.navbar {
    width: 100%;
    height: 64px;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    z-index: 10;

    .navbar-left {
        display: flex;
        flex-direction: row;
        align-items: center;

        .collapse {
            font-size: 18px;
            margin-left: 20px;
            cursor: pointer;
            color: #666666;
        }
    }

    .navbar-right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin: 0;

        li:nth-of-type(1) {
            margin-right: 20px;

            i {
                font-size: 18px;
            }
        }

        .nickname {
            cursor: pointer;
            display: flex;
            align-items: center;
            margin-right: 20px;
            line-height: 36px;

            .photo {
                font-size: 24px;
                margin-right: 10px;
            }
            h3 {
                margin-bottom: 0;
                line-height: 36px;
            }
        }
    }

    .system-name {
        font-size: 24px;
        color: #333;
        margin-left: 30px;
    }
}
</style>
